import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false, name: 'required_errormsg' })
export class RequiredErrorMessagePipe implements PipeTransform {
  transform(value: string = null): string {
    return `${value || 'This field'} is required`;
  }
}

@Pipe({
  standalone: false, name: 'invalid_errormsg' })
export class InvalidErrorMessagePipe implements PipeTransform {
  transform(value: string = null): string {
    return `${value || 'This value'} is invalid`;
  }
}

@Pipe({
  standalone: false, name: 'duplicate_errormsg' })
export class DuplicateErrorMessagePipe implements PipeTransform {
  transform(value: string = null): string {
    return `${value || 'This value'} already exists`;
  }
}

@Pipe({
  standalone: false, name: 'maxlength_errormsg' })
export class MaxlengthErrorMessagePipe implements PipeTransform {
  transform(value: string = null): string {
    return `${value || 'This value'} is too long`;
  }
}

@Pipe({
  standalone: false, name: 'min_errormsg' })
export class MinErrorMessagePipe implements PipeTransform {
  transform(value: string = null): string {
    return `${value || 'This number'} is too small`;
  }
}

@Pipe({
  standalone: false, name: 'max_errormsg' })
export class MaxErrorMessagePipe implements PipeTransform {
  transform(value: string = null): string {
    return `${value || 'This number'} is too large`;
  }
}

@Pipe({
  standalone: false, name: 'email_errormsg' })
export class EmailErrorMessagePipe implements EmailErrorMessagePipe {
  transform(value: string = null): string {
    return `${value || 'This value'} must be a valid email address`;
  }
}
